<template>
  <BaseModal
    :modal-id="modalCreateReviewSellerId"
    content-style="max-width: 60rem;"
    scrollable
    mobile-full-screen
    @before-open="beforeOpen"
  >
    <template #default="{ close }">
      <div class="modal-body modal-body--full-mobile">
        <header class="modal-body__head">
          <div class="modal-body__title">
            {{ $t('seller.title_leave_feedback') }} {{ sellerName }}
          </div>

          <div
            class="modal-body__close icon-times-light z-index__2"
            tabindex="0"
            @click="handleClose(close)"
          />
        </header>

        <SellerReviewsForm
          v-if="sellerSlug && lastOrder"
          :seller-slug="sellerSlug"
          :last-order="lastOrder"
          @review-success="reviewSuccess"
          @close="handleClose(close)"
        />
      </div>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import { modalCreateReviewSellerId } from '@/constants/modalNames'
import type { OrderRecord } from '~/types/checkout'
import type { ModalSellerReviewParams, SellerReview } from '~/types/review'

type Emits = {
  (e: 'review-success', review: SellerReview): void
}
const emit = defineEmits<Emits>()

const query = useRoute().query

const sellerName = shallowRef('')
const sellerSlug = shallowRef<string | null>(null)
const lastOrder = shallowRef<OrderRecord | null>(null)

const beforeOpen = (e: any) => {
  const params = e.params as ModalSellerReviewParams

  sellerName.value = params.sellerName
  sellerSlug.value = params.sellerSlug
  lastOrder.value = params.lastOrder
}

const handleClose = async (callback: () => void) => {
  callback()

  if (query.create_seller_review) {
    await navigateTo({}, { replace: true })
  }
}

const reviewSuccess = (review: SellerReview) => {
  emit('review-success', review)
}

</script>
<style scoped lang="scss">
.form-row {
  display: block;
}
</style>
